import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { type AaFeatureStats, type InputTableQuerySpec, type Protein } from "../../graphql.js";
import { updateLastOpenProteinFeatureTableSpec } from "../../redux/modules/protein.js";
import { createTableSpecForProteinParent } from "../../redux/modules/table-data.js";
import { type IAppState } from "../../redux/reducer.js";
import { type ReduxDispatch } from "../../redux/redux-utils.js";
import { ENTITY_TYPE } from "../../settings/settings.js";
import GenomicFeatureSelector, { type IFeatureOption } from "./GenomicFeatureSelector.js";

interface IProteinFeatureSelectorProps {
  protein: Protein;
}

const ProteinFeatureSelector = (props: IProteinFeatureSelectorProps) => {
  const proteinState = useSelector((state: IAppState) => state.protein);

  const [optionList, setOptionList] = useState<IFeatureOption[]>(null);
  const dispatch = useDispatch<ReduxDispatch>();

  useEffect(() => {
    const options: IFeatureOption[] =
      props.protein?.featureStatsData.map((a: AaFeatureStats) => {
        return {
          label: a.featureTypeName,
          color: null,
          showColorBadge: false, // do not show the color badge anymore
          tableQuerySpec: createTableSpecForProteinParent(ENTITY_TYPE.AAFEATURE, props.protein?.id, a.featureTypeId),
        };
      }) || [];

    setOptionList(options);
  }, [props.protein]);

  return (
    <GenomicFeatureSelector
      options={optionList}
      setLastOpenFeatureTableSpec={(tableSpec: InputTableQuerySpec) =>
        dispatch(updateLastOpenProteinFeatureTableSpec(tableSpec))
      }
      lastOpenFeatureTableSpec={proteinState.lastOpenFeatureTableSpec}
    />
  );
};

export default ProteinFeatureSelector;
